<template>
    <!--热点视频[[-->
    <div class="radar-main g-laboratory-padding hot-words-main hot-video-main">
        <div class="hot-words-block">
            <radar-query-box @search="doSearch" ref="raderQueryBox" :hide-classes="true"></radar-query-box>
            <!--热词条[[-->
            <div
                class="g-laboratory-analysis-item"
                style="display: block;"
                v-if="paginationConf.total>0"
            >
                <p class="hot-word">
                    <strong>为您查到{{ paginationConf.total }}个相关结果</strong>
                </p>
            </div>
            <!--热词条]]-->
            <!--热词条[[-->
            <div class="g-laboratory-analysis-item" style="display: block;" v-else>
                <p class="hot-word">没有找到相关结果</p>
                <a class="g-laboratory-a back-btn" href="javascript:;">返回</a>
            </div>
            <!--热词条]]-->
        </div>

        <div
            class="hot-words-block sort-wrap without-line"
            style="display: block;"
            v-loading="loading"
        >
            <div class="f-clearfix select-item">
                <div class="f-fl select-item-main" @click="changeListOrder('new')">
                    <a
                        href="javascript:;"
                        :class="params.order===0 ? 'select-on' : 'select-off'"
                    >最新排序</a>
                </div>
                <div class="f-fl select-item-main" @click="changeListOrder('hot')">
                    <a
                        href="javascript:;"
                        :class="params.order===1 ? 'select-on' : 'select-off'"
                    >最热排序</a>
                </div>
                <!--<div class="f-fr select-item-right">-->
                <!--已为您找到4个结果-->
                <!--</div>-->
            </div>

            <!--结果显示区域[[-->
            <div class="result-show-area">
                <ul class="videos-list">
                    <!--单条视频信息[[-->
                    <li
                        class="f-clearfix video-box"
                        v-for="(item,index) in hotVideoData"
                        :key="index"
                    >
                        <div class="f-fl video-box-left">
                            <p class="video-name">
                                <i class="ico ico-television"></i>
                                <a :href="item.url">{{ item.title }}</a>
                            </p>
                            <p class="video-detail-wrap">
                                <span class="video-detail" href="javascript:;">
                                    <i class="ico ico-connect"></i>
                                    {{ item.category }}
                                </span>
                                <span class="video-detail" href="javascript:;">
                                    <i class="video-detail-icon video-detail-icon-nickname"></i>
                                    {{ item.author }}
                                </span>
                                <span class="video-detail" href="javascript:;">
                                    <i class="ico ico-time"></i>
                                    {{ item.create_date }}
                                </span>
                            </p>
                        </div>
                        <div class="f-fr video-box-right">
                            <div class="f-clearfix">
                                <div class="f-fl interactive-count">
                                    <p class="counts-num">{{item.play }}</p>
                                    <p class="interactive-name">播放量</p>
                                </div>
                                <div class="f-fr interactive-count">
                                    <p class="counts-num">{{item.comment}}</p>
                                    <p class="interactive-name">评论量</p>
                                </div>
                            </div>
                        </div>
                    </li>
                    <!--单条视频信息-->
                </ul>
            </div>
            <!--结果显示区域]]-->
        </div>
        <!-- 分页[[ -->
        <pagination
            v-if="paginationConf.total >0"
            :total="paginationConf.total"
            :page-size="paginationConf.pageSize"
            @change="pageChange"
            ref="pager"
        ></pagination>
        <!-- 分页]] -->
    </div>
    <!--热点视频]]-->
</template>
<style lang="scss" scoped>
@import "~Assets/sass/pages/v4/laboratory/radar.scss";
.select-item-main a {
    display: block;
    height: 30px;
    line-height: 30px;
    border: 1px solid #fd7e28;
    font-size: 14px;
    text-align: center;
    border-radius: 2px;
    transition: all 0.3s;
    width: 5rem;
    margin-left: 3px;
}
.select-on {
    background: #fd7e28;
    color: #fff;
}
.select-off {
    background: #fff;
    color: #fd7e28;
}
</style>

<script>
import radarQueryBox from "./radar_query_box";
import pagination from "Components/v4/pagination/pagination_v4";
import {
    TrendHotVideoData 
} from "Services/getData.js";
export default {
    data() {
        return {
            paginationConf: {
                total: 0,
                pageSize: 10
            },
            params: {
                pageIndex: 0,
                pageSize: 10,
                time: 3,
                order: 0,
                classId: "",
                word: ""
            },
            queryCount: 0, // 查询结果
            hotVideoData: [],
            loading: true
        };
    },
    components: {
        radarQueryBox,
        pagination
    },
    mounted() {
        this.getHotVideoList();
    },
    methods: {
        changeListOrder(order) {
            if (order == "new") {
                this.params.order = 0;
            } else {
                this.params.order = 1;
            }
            this.getHotVideoList();
        },
        async getHotVideoList() {
            let param = this.params;
            this.loading = true;
            let response = await TrendHotVideoData(param);
            if (response.status == 200) {
                let data = response.data;
                if (data.code == 0) {
                    this.hotVideoData = data.data.data;
                    this.paginationConf.total = data.data.count;
                }
            }
            this.loading = false;
        },
        pageChange(param) {
            // this.params.pageSize = param.pageSize; // 发送给接口的字段
            this.params.pageIndex = param.pageIndex - 1; // 发送给接口的字段
            this.getHotVideoList();
        },
        doSearch(param) {
            if (this.paginationConf.total > 0) {
                this.$refs.pager.first();
            }
            this.params.pageIndex = 0;
            this.params.classId = param.classId;
            this.params.word = param.searchContent;
            this.params.time = param.time;
            this.getHotVideoList();
        }
    }
};
</script>
